import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

// Context
import { AuthProvider, CartProvider } from "./context/AppContext";
import { LanguageProvider } from "./context/LanguageContext";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";

// Pages
import HomePage from "./pages/HomePage";
import ExperiencesPage from "./pages/ExperiencesPage";
import ExperienceDetailPage from "./pages/ExperienceDetailPage";
import CategoriesPage from "./pages/CategoriesPage";
import ContactPage from "./pages/ContactPage";
import CheckoutPage from "./pages/CheckoutPage";
import ProfilePage from "./pages/ProfilePage";
import AboutPage from "./pages/AboutPage";
import MembershipPage from "./pages/MembershipPage";
import PartnerPage from "./pages/PartnerPage";
import CustomerServicePage from "./pages/CustomerServicePage";
import AdminPage from "./pages/AdminPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  // Seed data on first load
  useEffect(() => {
    const seedData = async () => {
      try {
        // Check if experiences exist
        const res = await axios.get(`${API}/experiences`);
        if (res.data.length === 0) {
          // Seed if empty
          await axios.post(`${API}/seed`);
          console.log("Data seeded successfully");
        }
      } catch (e) {
        console.error("Error checking/seeding data:", e);
      }
    };
    seedData();
  }, []);

  return (
    <div className="App flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/upplevelser" element={<ExperiencesPage />} />
          <Route path="/upplevelse/:id" element={<ExperienceDetailPage />} />
          <Route path="/kategorier" element={<CategoriesPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/kassa" element={<CheckoutPage />} />
          <Route path="/profil" element={<ProfilePage />} />
          <Route path="/vad-ar-vardagslyx" element={<AboutPage />} />
          <Route path="/bli-medlem" element={<MembershipPage />} />
          <Route path="/bli-partner" element={<PartnerPage />} />
          <Route path="/kundservice" element={<CustomerServicePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
      <Footer />
      <Chatbot />
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#2C3E36',
            color: '#fff',
            border: 'none',
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
